export default "__VITE_ASSET__bRIWevCn__"